





































































import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog } from 'vant';

class Leave {
  IsDropOut?: boolean | undefined = false;
  className?: string | undefined = '';
  startDate?: string | undefined;
  endDate?: string | undefined;
  pageIndex?: number | undefined;
  pageSize?: number | undefined;
}

@Component({})
export default class LeaveList extends Vue {
  // @Prop() listData: any;
  @Prop() leaveStatus: models.CommonAuditStatus;
  showRevokeDialog: boolean = false;
  revokeItem: any = {};
  loading: boolean = false;
  finished: boolean = false;
  leaveList: any = [];
  underReview: any = []; // 审核中
  passedList: any = []; //已通过
  failedList: any = []; //未通过数据
  leaveForm: Leave = new Leave();

  listData: any = [];
  @Watch('leaveStatus', { immediate: true })
  async onTrainStatusChangeAsync(val: string) {
    this.getListData();
  }

  get CommonAuditStatus() {
    return models.CommonAuditStatus;
  }
  // async getListData() {
  //   this.loading = true;
  //   try {
  //     let state = CommonAuditStatus.审核中;
  //     if (this.leaveStatus == '已通过') {
  //       state = CommonAuditStatus.已通过;
  //     }
  //     if (this.leaveStatus == '未通过') {
  //       state = CommonAuditStatus.未通过;
  //     }
  //     const { data } = await api.Leaves.findMyLeaves_GET({ state: state });
  //     this.listData = data!.items;
  //   } finally {
  //     this.loading = false;
  //     this.finished = true;
  //   }
  // }

  getListData() {
    if (this.leaveStatus == this.CommonAuditStatus.待审核) this.listData = this.underReview;
    if (this.leaveStatus == this.CommonAuditStatus.已通过) this.listData = this.passedList;
    if (this.leaveStatus == this.CommonAuditStatus.未通过) this.listData = this.failedList;
  }

  async getMyLeaves() {
    this.loading = true;
    try {
      const { data } = await api.Leaves.findMyLeaves_GET(this.leaveForm);
      this.leaveList = data.value.items;
      this.listData = this.leaveList;
      this.underReview = this.leaveList.map(e => e.orgAuditStatus == this.CommonAuditStatus.待审核);
      this.passedList = this.leaveList.map(e => e.orgAuditStatus == this.CommonAuditStatus.已通过);
      this.failedList = this.leaveList.map(e => e.orgAuditStatus == this.CommonAuditStatus.未通过);
    } catch (error) {
      Dialog.alert(error.message);
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  //撤销请假
  revoke(item: any) {
    this.showRevokeDialog = true;
    this.revokeItem = item;
  }
  async revokeAsync() {
    // //系统返回提交状态
    // try {
    //   let revokeIds = [this.revokeItem.id];
    //   const { data, success, message } = await api.Leaves.deletes_POST({
    //     ids: revokeIds,
    //   });
    //   if (success) {
    //     this.showRevokeDialog = false;
    //     this.$dialog.alert({
    //       message: "撤销成功",
    //     });
    //     //撤销成功，清空该项
    //     for (let i in this.listData) {
    //       if (this.listData[i].id == this.revokeItem.id) {
    //         this.listData.splice(i, 1);
    //       }
    //     }
    //   } else {
    //     this.showRevokeDialog = false;
    //     this.$dialog.alert({
    //       message: "撤销失败",
    //     });
    //   }
    // } finally {
    //   this.loading = false;
    //   this.finished = true;
    // }
  }

  mounted() {
    this.getMyLeaves();
  }
}
